module.exports = __webpack_public_path__ + "static/media/give4forestBadge.21add2fb.png";